function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./ManualTimeEntries.css";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";
import Badge from "react-bootstrap/Badge";
import { FilterContext, UserContext } from "../index";
import { MdDeleteForever } from "react-icons/md";
import { arrayToStringOutput } from "./../SideMenu/Header";
var data = [{
  workName: "Visited client office ",
  totalHours: "2 hours",
  status: "pending"
}, {
  workName: "Went to workshop",
  totalHours: "3 hours 30 mins",
  status: "rejected"
}, {
  workName: "Went to audit in client location ",
  totalHours: "3 hours",
  status: "approved"
}];
var ManualTimeEntries = function ManualTimeEntries(props) {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    manualTimeModal = _React$useState2[0],
    setManualTimeModal = _React$useState2[1];
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    startDate = _React$useContext2.startDate,
    endDate = _React$useContext2.endDate,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationUserCount = _React$useContext2.organisationUserCount,
    organisationBilling = _React$useContext2.organisationBilling;
  var dateFilter = arrayToStringOutput([startDate, endDate], organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var handleClose = function handleClose() {
    return setManualTimeModal(null);
  };
  var handleShow = function handleShow(data) {
    setManualTimeModal(data);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-root-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-root-header-name"
  }, "Manual Time Entries"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "Manual-time-entries-root-header-button",
    onClick: function onClick() {
      return handleShow("true");
    }
  }, "Add Manual Time Entry")), /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-root-date-filter"
  }, dateFilter), /*#__PURE__*/React.createElement("div", {
    className: "Manual-time-entries-root-body"
  }, data !== null && data !== void 0 && data.length ? data === null || data === void 0 ? void 0 : data.map(function (workData, key) {
    return /*#__PURE__*/React.createElement("div", {
      className: "Manual-time-entries-root-body-listing-content"
    }, /*#__PURE__*/React.createElement(Badge, {
      pill: true,
      variant: workData.status === "approved" ? "success" : workData.status === "rejected" ? "danger" : "warning",
      className: "Manual-time-entries-root-body-listing-content-status"
    }, workData.status), /*#__PURE__*/React.createElement("div", {
      className: "Manual-time-entries-root-body-listing-content-text"
    }, workData.workName, " - ", workData.totalHours), /*#__PURE__*/React.createElement("div", {
      className: "Manual-time-entries-root-body-listing-content-text-delete"
    }, /*#__PURE__*/React.createElement(MdDeleteForever, null)));
  }) : /*#__PURE__*/React.createElement("div", null, "No data found !!!")), /*#__PURE__*/React.createElement(ManualTimeModal, {
    manualTimeModal: manualTimeModal,
    handleClose: handleClose,
    dateFilter: dateFilter
  }));
};
var ManualTimeModal = function ManualTimeModal(props) {
  var handleClose = props.handleClose,
    manualTimeModal = props.manualTimeModal,
    organisationId = props.organisationId,
    startDate = props.startDate,
    endDate = props.endDate,
    dateFilter = props.dateFilter;
  if (manualTimeModal === null) {
    return null;
  }
  var _React$useState3 = React.useState(startDate),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    dateValues = _React$useState4[0],
    setDateValues = _React$useState4[1];
  var currentDate = moment();
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    className: "manual-timer-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "manual-timer-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manual-timer-modal-title"
  }, "Add Manual Time")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "manual-timer-modal-body"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      manualTimeName: ""
    }
    //   validationSchema={TeamsSchema}
    //   onSubmit={teamModalShow.modalType === "editTeam" ? handleEditSubmit : handleSubmit}
  }, function (_ref) {
    var setFieldValue = _ref.setFieldValue;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manual-timer-modal-body-formik"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "manualTimeName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "rule-setting-err"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Field, _extends({
        as: Form.Control,
        name: "manualTimeName",
        type: "text",
        placeholder: "What have you worked on?"
        //className="manage-teams-edit-task-label-input"
      }, field)));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "manualHour"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: "manual-time-hour"
      }, meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "rule-setting-err"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Field, _extends({
        as: Form.Control,
        name: "manualHour",
        type: "text",
        placeholder: "160 mins"
      }, field)));
    }), /*#__PURE__*/React.createElement(DatePicker
    // customInput={
    //             <>
    //             <FaRegCalendarAlt className="page-content-wrapper-menu-filter-date-icon" />
    //             <Field name="manualTimeName">
    //   {(fieldProps) => {
    //     const { field, meta } = fieldProps;
    //     return (
    //       <Form.Group>
    //         {meta.error && meta.touched ? (
    //           <Form.Label className="rule-setting-err">{meta.error}</Form.Label>
    //         ) : null}
    //         <Field
    //           as={Form.Control}
    //           name="manualTimeName"
    //           type="text"
    //           placeholder="What have you worked on?"
    //           //className="manage-teams-edit-task-label-input"
    //           {...field}
    //         />
    //       </Form.Group>
    //     );
    //   }}
    // </Field>

    // </>

    //           }
    , {
      placeholderText: "Date",
      selected: dateValues,
      showTimeSelect: true,
      maxDate: currentDate,
      dateFormat: "MMMM d, yyyy h:mm aa",
      onChange: function onChange(date) {
        return setDateValues(date);
      },
      className: "manual-page-content-wrapper-menu-filter-date-date-section"
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "manual-time-add-button",
      type: "submit"
    }, "ADD")), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "manual-time-modal-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "Manual-time-entries-root-body"
    }, data !== null && data !== void 0 && data.length ? data === null || data === void 0 ? void 0 : data.map(function (workData, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "Manual-time-entries-root-body-listing-content"
      }, /*#__PURE__*/React.createElement(Badge, {
        pill: true,
        variant: workData.status === "approved" ? "success" : workData.status === "rejected" ? "danger" : "warning",
        className: "Manual-time-entries-root-body-listing-content-status"
      }, workData.status), /*#__PURE__*/React.createElement("div", {
        className: "Manual-time-entries-root-body-listing-content-text"
      }, workData.workName, " - ", workData.totalHours), /*#__PURE__*/React.createElement("div", {
        className: "Manual-time-entries-root-body-listing-content-text-delete"
      }, /*#__PURE__*/React.createElement(MdDeleteForever, null)));
    }) : /*#__PURE__*/React.createElement("div", null, "No data found !!!")))))));
  })));
};
export default ManualTimeEntries;